import { Component } from '@angular/core';
import { CoreSelectors } from '@next/core-lib';
import { RootState } from '@next/core-lib/app';
import { DialogService } from '@next/core-lib/dialog';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { listAnimations } from '../../../animations';
import { Barn } from '../../models/barn.model';
import * as barnActions from '../../store/actions/barn.actions';
import { getBarns } from '../../store/selectors/barn.selector';
import { BarnItemComponent } from '../barn-item/barn-item.component';

@Component({
  selector: 'app-barn-overview',
  templateUrl: 'barn-overview.component.html',
  styleUrls: ['./barn-overview.component.scss'],
  animations: [listAnimations],
  standalone: false,
})
export class BarnOverviewComponent {
  barns$ = this.store.select(getBarns);
  isLoading$: Observable<boolean> = this.store.select(CoreSelectors.selectLoading);

  constructor(
    private readonly store: Store<RootState>,
    private readonly dialog: DialogService,
  ) {}

  openBarnDetail(barn?: Barn) {
    this.dialog.form(BarnItemComponent, { barn: barn ? barn : <Barn>{} });
  }

  delete(event: Event, barn: Barn) {
    event.preventDefault();
    event.stopImmediatePropagation();

    if (barn && barn.id) {
      this.store.dispatch(barnActions.deleteBarnWithConfirmation({ barn }));
    }
  }
}
